import { useEffect } from "react";

const SITE_URL = "https://oxford-cleaners.com";

const upsert = (selector, attrs, contentAttr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute(contentAttr, value);
};

export const Seo = ({ title, description, path = "/", jsonLd = null, noindex = false }) => {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    document.title = title;
    upsert('meta[name="description"]', { name: "description" }, "content", description);
    if (noindex) {
      upsert('meta[name="robots"]', { name: "robots" }, "content", "noindex, nofollow");
    }
    upsert('link[rel="canonical"]', { rel: "canonical" }, "href", url);
    upsert('meta[property="og:title"]', { property: "og:title" }, "content", title);
    upsert('meta[property="og:description"]', { property: "og:description" }, "content", description);
    upsert('meta[property="og:url"]', { property: "og:url" }, "content", url);
    upsert('meta[property="og:type"]', { property: "og:type" }, "content", "website");
    upsert('meta[name="twitter:card"]', { name: "twitter:card" }, "content", "summary");
    upsert('meta[name="twitter:title"]', { name: "twitter:title" }, "content", title);
    upsert('meta[name="twitter:description"]', { name: "twitter:description" }, "content", description);
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-page", "true");
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
    };
  }, [title, description, path, jsonLd]);
  return null;
};
